import React from 'react'
import Moment from 'react-moment'
import { Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

let tablecolour = ''

const LowInventoryUnit = ({ unit }) => {
  if (unit.qty === 0) {
    tablecolour = 'table-danger'
  } else if (unit.qty <= unit.lowinventory) {
    tablecolour = 'table-warning'
  }

  return (
    <tr className={tablecolour}>
      <td>{unit.upc}</td>
      <td>{unit.item}</td>
      <td>{unit.manufacturer}</td>
      <td>{unit.subname}</td>
      <td>{unit.qty}</td>
      <td>{unit.lowinventory}</td>
      <td align='right'>
        {unit.price.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })}
      </td>
      <td align='right'>
        <Moment format='M/D/YY, h:mm a'>{new Date(unit.updatedAt)}</Moment>
      </td>
      <td>
        <LinkContainer to={`/inventory/edit/${unit._id}`}>
          <Button variant='primary' size='sm'>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        </LinkContainer>
      </td>
    </tr>
  )
}

export default LowInventoryUnit
